// extracted by mini-css-extract-plugin
export default {"cce":"CrawlCostEstimator_cce__0buSb","cceOptions":"CrawlCostEstimator_cceOptions__xbKsW","ellipseArrangement":"CrawlCostEstimator_ellipseArrangement__FzS9G"};